import './CountryPage.css';

export const Overview = ({ country }) => {
    return (
        <div className="main-content">
            <section className="overview">
            <h2>{country.overview.title}</h2>
            {country.overview.descriptions.map((desc, index) => (
                <p key={index}>{desc}</p>
            ))}
                <h3>Why study in {country.name}?</h3>
                <div className="highlights">
                    {country.highlights.map((highlight, index) => (
                        <div key={index} className="highlight-item">
                            <i className={highlight.icon}></i>
                            <h4>{highlight.title}</h4>
                            <p>{highlight.description}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="key-facts">
                <h2>Key facts to study in {country.name}</h2>
                <div className="facts-grid">
                    {country.keyFacts.map((fact, index) => (
                        <div key={index} className="fact-card">
                            <div className="fact-number">{fact.factNumber}</div>
                            <div className="fact-label">{fact.factLabel}</div>
                        </div>
                    ))}
                </div>
            </section>

            <section className="country-stats">
                <h2>Country Stats</h2>
                <div className="stats-grid">
                    <div className="stat-item">
                        <strong>Capital:</strong> {country.stats.capital}
                    </div>
                    <div className="stat-item">
                        <strong>Total Population (2025):</strong> {country.stats.poplulation}
                    </div>
                    <div className="stat-item">
                        <strong>Economic Growth Rate (2025):</strong> {country.stats.economicGrowthRate}
                    </div>
                    <div className="stat-item">
                        <strong>Primary Language:</strong> {country.stats.language}
                    </div>
                    <div className="stat-item">
                        <strong>Weather (August):</strong>
                        <ul>
                            {country.stats.weather.map((weather, index) => (
                                <li key={index}>{weather}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    );
};